import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { defer } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';

// URLs that must never trigger the global loader.
// Two categories:
//  1. Background/polling calls (unchanged)
//  2. Typeahead / autocomplete calls — fire on every keystroke and must
//     never cause a full-screen overlay flash.
const SILENT_URLS = [
  // background / polling
  'auth/refresh-token',
  'notification/unread-count',
  // typeahead / incremental search (fire on every keystroke)
  'supplier/searchByName',
  'project/searchByName',
  'ponew/searchPoByPoCode',
  'client/searchByName',
  'user/searchByNameInput/',
];

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  const isSilent = SILENT_URLS.some((url) => req.url.includes(url));
  if (isSilent) {
    return next(req);
  }

  // show() runs inside defer so it is always paired with the finalize teardown,
  // even if the rest of the chain throws while the request is being created.
  // An unpaired show() leaves the overlay up for good, blocking every click.
  return defer(() => {
    loadingService.show();
    return next(req);
  }).pipe(finalize(() => loadingService.hide()));
};
